import React from 'react'

import Product from '@cinch/oxd-components/dealer-product-list-card/src'

const PendingProduct = () => (
  <Product
    id={0}
    image={''}
    price={'Pending'}
    location={'Pending'}
    title={'Pending'}
    subtitle={'Pending'}
    onSave={() => 0}
    isSaved={false}
    isPending={true}
    isAvailable={true}
    tags={[]}
    hasCompareButton={false}
    linkToProductView={false}
    unavailable={' '}
    isDeliverable={false}
    imageCount={0}
  />
)

export default PendingProduct
